module.exports = __webpack_public_path__ + "static/media/niger-delta.4e3b7ed8.jpg";